import React, {useEffect, useState} from "react"
import { navigate } from '@reach/router'
import _ from "lodash"

import chartService, {ChartChild} from "data/chart"
import { Button_s } from "styles/app-styles"

type ChildCountProps = {
  id: string
  chartid: number
  childType: ChartChild
  count: number
}

const ChildCount = (props: ChildCountProps) => {
  const count = props.count

  let route = ""
  switch(props.childType) {
    case "summaryaccount":
      route = "summary-accounts"
      break;
    case "detailaccount":
      route = "detail-accounts"
      break;
    case "cashflowmap":
      route = "cash-flow-map"
      break;
  }

  return (
    <Button_s
      className="detailed-route-button"
      id={props.id}
      key={props.id}
      style={{height: '26px'}}
      onClick={()=>navigate(`/n/asset-management/chart/${props.chartid}/${route}`)}>
        {`View/Edit: (${count})`}
    </Button_s>
  )
}

export default ChildCount
